(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saisen-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-feature-showcase')) {
    class SsFeatureShowcase extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.ssf__item'));
        this.single = this.dataset.mode !== 'multiple';
        this.allowClose = this.dataset.allowClose === 'true';
        this.hoverMode = this.dataset.trigger === 'hover' && window.matchMedia('(hover: hover)').matches;

        this.items.forEach((item, i) => {
          const trigger = item.querySelector('.ssf__trigger');
          const hasDesc = !item.classList.contains('ssf__item--no-desc');
          trigger.addEventListener('click', () => this.toggle(i));
          if (this.hoverMode) item.addEventListener('mouseenter', () => this.open(i));
          if (!hasDesc) trigger.setAttribute('aria-expanded', 'false');
        });

        this.querySelectorAll('.ssf__dot').forEach((dot) => {
          const i = Number(dot.dataset.index);
          dot.addEventListener('click', () => this.open(i));
          if (this.hoverMode) dot.addEventListener('mouseenter', () => this.open(i));
        });

        // Éditeur de thème : sélectionner un bloc l'ouvre.
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.ssf__item');
          if (item) this.open(this.items.indexOf(item));
        });
      }

      isOpen(i) {
        return this.items[i] && this.items[i].classList.contains('is-active');
      }

      toggle(i) {
        if (this.isOpen(i)) {
          if (!this.single || this.allowClose) this.close(i);
        } else {
          this.open(i);
        }
      }

      open(i) {
        if (!this.items[i]) return;
        if (this.single) this.items.forEach((_, j) => j !== i && this.setState(j, false));
        this.setState(i, true);
      }

      close(i) {
        this.setState(i, false);
      }

      setState(i, active) {
        const item = this.items[i];
        if (!item) return;
        item.classList.toggle('is-active', active);
        const trigger = item.querySelector('.ssf__trigger');
        if (trigger && !item.classList.contains('ssf__item--no-desc')) {
          trigger.setAttribute('aria-expanded', String(active));
        }
        this.querySelectorAll(`[data-index="${i}"].ssf__dot, [data-index="${i}"].ssf__label, [data-index="${i}"].ssf__line`)
          .forEach((el) => el.classList.toggle('is-active', active));
      }
    }
    customElements.define('ss-feature-showcase', SsFeatureShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saisen-tech-layers"] && !Shopify.designMode) return;
  try {
    
  class SaisenTechLayers extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.stl__nav-item'));
      this.items.forEach((item) => {
        const trigger = item.querySelector('.stl__nav-trigger');
        trigger.addEventListener('click', () => this.activate(item));
      });
      const reset = this.querySelector('.stl__reset');
      if (reset) reset.addEventListener('click', () => this.assemble());
    }

    activate(item) {
      const key = item.dataset.layer;
      this.setAttribute('data-state', 'exploded');
      this.setAttribute('data-active', key);
      this.items.forEach((el) => el.classList.toggle('is-active', el === item));
      const trigger = item.querySelector('.stl__nav-trigger');
      this.items.forEach((el) => {
        el.querySelector('.stl__nav-trigger').setAttribute('aria-pressed', el === item ? 'true' : 'false');
      });
    }

    assemble() {
      this.setAttribute('data-state', 'assembled');
    }
  }
  if (!customElements.get('saisen-tech-layers')) {
    customElements.define('saisen-tech-layers', SaisenTechLayers);
  }

  } catch(e) { console.error(e); }
})();
})();
